import { useReducedMotion, motion } from "framer-motion";
import { CTA, PRICE, CORE_VALUE } from "../config/brand";
import { FadeUp, LineReveal } from "../components/Reveal";
import { PurchaseButton } from "../components/PurchaseButton";

export const FinalCTA = () => {
  const reduce = useReducedMotion();
  return (
  <section
    className="relative overflow-hidden bg-plum"
    aria-label="Final call to action"
    data-testid="final-cta-section"
  >
    <div aria-hidden="true" className="absolute inset-0">
      <img
        src="/assets/quiet.png"
        alt=""
        className="h-full w-full object-cover opacity-[0.16]"
        width={1600}
        height={900}
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-plum/75 via-plum/60 to-plum" />
      {!reduce && (
        <>
          <motion.div
            className="absolute -left-40 top-8 h-[420px] w-[420px] rounded-full bg-rose/20 blur-[110px]"
            animate={{ x: [0, 70, 0], y: [0, 45, 0] }}
            transition={{ duration: 26, repeat: Infinity, ease: "easeInOut" }}
          />
          <motion.div
            className="absolute -right-44 bottom-0 h-[480px] w-[480px] rounded-full bg-blush/15 blur-[120px]"
            animate={{ x: [0, -80, 0], y: [0, -35, 0] }}
            transition={{ duration: 32, repeat: Infinity, ease: "easeInOut" }}
          />
        </>
      )}
    </div>
    <div className="grain relative mx-auto max-w-[900px] px-5 py-24 text-center sm:px-8 lg:py-32">
      <LineReveal
        as="h2"
        lines={["You can build a life", "that works for you."]}
        className="font-serif text-4xl font-medium leading-[1.08] tracking-tight text-ivory sm:text-5xl lg:text-[3.6rem]"
      />
      <FadeUp delay={0.2}>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-ivory/80 sm:text-lg">
          Make everyday life more manageable—and make more room for the goals
          you've been putting on hold.
        </p>
      </FadeUp>
      <FadeUp delay={0.3} className="mt-10 flex flex-col items-center gap-4">
        <p className="font-serif text-2xl text-ivory/70" data-testid="final-value">
          <span className="line-through">{CORE_VALUE} core value</span>
        </p>
        <p className="font-serif text-6xl font-medium leading-none text-ivory" data-testid="final-price">
          {PRICE} <span className="text-2xl italic text-blush">today</span>
        </p>
        <PurchaseButton event="final_cta_click" testId="final-get-system-button">
          {CTA.primary}
        </PurchaseButton>
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-ivory/60">
          {CTA.microcopy}
        </p>
      </FadeUp>
    </div>
  </section>
  );
};
